module.exports = __webpack_public_path__ + "img/refresh-circle.441b0b03.svg";